<template>
  <ion-page>
    <ion-content class="ion-padding">
      <ion-header collapse="condense">
        <ion-toolbar color="primary">
          <ion-title>Crear ubicación</ion-title>
        </ion-toolbar>
      </ion-header>

      <div class="container">
        <!-- Componente reutilizable: misma UI y flujo que en ImprimirEtiquetaUbicacionPage -->
        <TablaUbicacion
          :zonaInit="zonaInit"
          :pasilloInit="pasilloInit"
          :e0Init="estanteInit"
          :e1Init="undefined"
          :a0Init="alturaInit"
          :a1Init="undefined"
          :p0Init="posicionInit"
          :p1Init="undefined"
          :single="true"
          @change="onTablaChange"
        />

        <!-- Preview de la ubicación compuesta -->
        <ion-item lines="none">
          <ion-label>
            <div class="preview">
              {{ ubicacionCompuesta || 'Completa los campos...' }}
            </div>
          </ion-label>
        </ion-item>

        <!-- Acciones -->
        <ion-row class="ion-justify-content-end ion-padding-top">
          <ion-button fill="clear" color="medium" @click="cancelar">Cancelar</ion-button>
          <ion-button color="primary" :disabled="!puedeConfirmar" @click="confirmar">Aceptar</ion-button>
        </ion-row>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue'
import { modalController } from '@ionic/vue'
import TablaUbicacion from '@/components/ubicaciones/TablaUbicacion.vue'

export default defineComponent({
  name: 'SeleccionUbicacionModal',
  components: { TablaUbicacion },
  props: {
    zonaInit: { type: String, default: 'ZOA' },
    pasilloInit: { type: Number, default: 0 },
    estanteInit: { type: Number, default: 0 },
    alturaInit: { type: Number, default: 0 },
    posicionInit: { type: Number, default: undefined }
  },
  data () {
    return {
      // Último estado emitido por TablaUbicacion
      seleccion: null
    }
  },
  computed: {
    puedeConfirmar () {
      // Confirmamos cuando el componente tenga una selección válida
      return !!(this.seleccion && this.seleccion.zona !== undefined && this.seleccion.pasillo !== undefined && this.seleccion.e0 !== undefined && this.seleccion.a0 !== undefined)
    },
    ubicacionCompuesta () {
      // Vista previa en base a lo emitido por TablaUbicacion
      return this.seleccion ? this.seleccion.composedSingle : ''
    }
  },
  methods: {
    // Recepción de cambios desde TablaUbicacion
    onTablaChange (payload) { this.seleccion = payload },
    cancelar () { modalController.dismiss(null, 'cancel') },
    confirmar () { modalController.dismiss(this.ubicacionCompuesta, 'confirm') }
  }
})
</script>

<style scoped>
.container { max-width: 700px; margin: 0 auto; }
.preview { font-size: 1.2rem; font-weight: 600; padding: 8px 0; }
</style>
